module.exports = __webpack_public_path__ + "img/csxz.36e32bb2.png";